import { ReactElement, ReactNode } from "react";
import { Box } from "@twilio-paste/core";
import { ChevronDownIcon } from "@twilio-paste/icons/esm/ChevronDownIcon";

import { Result } from "./sub";
import { copy } from "./definitions";

import { TrackingButton } from "@twiliointernal/e2-commons-shared-ui";
import styles from "./SearchResults.module.css";
import {
  ResultProps,
  SearchResultsProps,
} from "@twiliointernal/e2-commons-shared-definitions";

const SearchResults = ({
  feedbackPrompt = copy.feedback.prompt,
  maxWidth = "size60",
  searchResults,
  shouldShowViewMoreButton = false,
  viewMoreResultsClick,
  viewMoreResultsTracking,
}: SearchResultsProps): ReactElement => {
  const renderResults = (): ReactNode[] =>
    searchResults.map(
      ({ trackingMethods, userMethods, ...rest }: ResultProps) => (
        <Result
          feedbackPrompt={feedbackPrompt}
          key={rest.id}
          trackingMethods={trackingMethods}
          userMethods={userMethods}
          {...rest}
        />
      )
    );

  return (
    <Box
      as="div"
      className={styles.outerSearchResultsContainer}
      maxWidth={maxWidth}
    >
      <Box
        as="section"
        className={styles.searchResultsContainer}
        width={maxWidth}
      >
        {renderResults()}
      </Box>

      {shouldShowViewMoreButton && (
        <Box as="div" className={styles.viewMoreResultsContainer}>
          <TrackingButton
            variant="link"
            onClick={viewMoreResultsClick}
            trackEvent={viewMoreResultsTracking}
          >
            {copy.buttonValue}
            <ChevronDownIcon decorative />
          </TrackingButton>
        </Box>
      )}
    </Box>
  );
};

export default SearchResults;
